import Side from "./Tabs/Side";
import Index from "./Tabs/Index";
import Rounded from "./Tabs/Rounded";

export default Object.assign(Index, { Side, Rounded });
